import React, { useState, useEffect } from 'react';
import { Tabs, Tab, Typography, Box, Button, TextField } from '@mui/material';
import WorkshopContent from './workshop/WorkshopContent';
import TutorialPage from './Tutorial/TutorialPage';
import EditTutorial from './Tutorial/EditTutorial';
import TutorialDetailView from './Tutorial/TutorialDetailView';
import { useSelector, useDispatch } from 'react-redux';
import { setHasReturned } from '../../redux/slices/editModeSlice'; // Adjust path as needed
import { setTutCurrentItem, setTutHasReturned } from '../../redux/slices/tutorialEditSlice';
import AdminQuizPage from './Quiz/QuizPage';
import { Tooltip, useMediaQuery, useTheme } from '@mui/material'
const TopbarTraining = () => {
  const dispatch = useDispatch();
  const [showEditPage, setShowEditPage] = useState(false);

  const hasReturned = useSelector(state => state.editMode.hasReturned);
  const tutEditMode = useSelector(
    state => state.tutorialEdit?.tutEditMode || false
  );
  const tutHasReturned = useSelector(
    state => state.tutorialEdit?.tutHasReturned || false
  );
  const currentItem = useSelector(state => state.tutorialEdit?.tutCurrentItem);
const theme = useTheme()
const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  console.log(
    'TopbarTraining Rendered - tutEditMode:',
    tutEditMode,
    'currentItem:',
    currentItem,
    'showEditPage:',
    showEditPage
  );
const quizEditMode = useSelector(
  state => state.quizEdit?.quizEditMode || false
);

const quizCurrentItem = useSelector(
  state => state.quizEdit?.quizCurrentItem
);
  useEffect(() => {
    console.log('useEffect: currentItem changed to:', currentItem);
  }, [currentItem]);

  useEffect(() => {
    // If hasReturned is true, set value to 1 (Workshops)
    if (hasReturned) {
      setActiveTab(1);
      dispatch(setHasReturned(false));
    }
  }, [hasReturned, dispatch]);

  useEffect(() => {
    // If tutHasReturned is true, set value to 0 (Tutorials)
    if (tutHasReturned) {
      setActiveTab(0);
      dispatch(setTutHasReturned(false));
    }
  }, [tutHasReturned, dispatch]);

  useEffect(() => {
    // Show EditTutorial only when in edit mode
    if (tutEditMode) {
      setShowEditPage(true);
    } else {
      setShowEditPage(false);
    }
    console.log('TopbarTraining useEffect triggered:', {
      tutEditMode,
      currentItem,
      showEditPage: tutEditMode,
    });
  }, [tutEditMode]);

  const [activeTab, setActiveTab] = useState(0);

  return (
    <div style={{ width: '100%', overflowX: 'hidden'}}>
      {/* Show TutorialDetailView when viewing (currentItem exists, not in edit mode) */}
{(currentItem && !tutEditMode) ? (
  <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
    <TutorialDetailView
      onBack={() => dispatch(setTutCurrentItem(null))}
    />
  </Box>
) : showEditPage ? (
  <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
    <EditTutorial onBack={() => setShowEditPage(false)} />
  </Box>
) : (quizEditMode || quizCurrentItem) ? (
  <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
    <AdminQuizPage />
  </Box>
) : ( 
        <>
          {/* Blue Header with Tabs (full width, each tab half width) */}
<Box
  sx={{
    display: 'flex',
    flexDirection: isMobile ? 'column' : 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: isMobile ? 1 : 0,
    padding: theme.spacing(1),
    marginBlock: '1rem',
    boxSizing: 'border-box'
  }}
>
  <Tabs
    value={activeTab}
    onChange={(e, newValue) => setActiveTab(newValue)}
    indicatorColor="none"
    sx={{
      padding: '8px',
      background: '#F4F4F4',
      borderRadius: '12px',
      '& .MuiTab-root': {
        color: '#333 !important',
        background: '#fff !important',
        border: '1px solid #E6E6E6 !important',
        borderRadius: '8px',
        marginInline: 0.5,
        padding: '8px 24px',
        textTransform: 'none',
        typography: 'body1'
      },
      '& .Mui-selected': {
        color: '#fff !important',
        background: '#333 !important',
        border: '1px solid #333 !important'
      }
    }}
  >
    <Tooltip title="View and manage Tutorials" arrow>
      <Tab label="Tutorials" />
    </Tooltip>

    <Tooltip title="View Workshops and sessions" arrow>
      <Tab label="Workshops" />
    </Tooltip>

    <Tooltip title="Manage Quizzes" arrow>
      <Tab label="Quizzes" />
    </Tooltip>
  </Tabs>
</Box>
          <TabPanel value={activeTab} index={0}>
            <TutorialPage />
          </TabPanel>

          <TabPanel value={activeTab} index={1}>
            <Box
              sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}
            >
              <WorkshopContent />
            </Box>
          </TabPanel>
          <TabPanel value={activeTab} index={2}>
  <AdminQuizPage />
</TabPanel>
        </>
      )}
    </div>
  );
};

const tabStyles = isSelected => ({
  border: '1px solid #ccc',
  borderRadius: '4px',
  backgroundColor: isSelected ? '#3434f5' : '#fff',
  color: isSelected ? '#fff' : 'inherit',
  padding: '8px 16px',
});

const TabPanel = ({ children, value, index, ...other }) => (
  <div
    role="tabpanel"
    hidden={value !== index}
    id={`tabpanel-${index}`}
    aria-labelledby={`tabpanel-${index}`}
    {...other}
    style={{ width: '100%' }}
  >
    {value === index && (
      <Box>
        {children}
      </Box>
    )}
  </div>
);

export default TopbarTraining;
